/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useRecurringProfiles = (page, queryParams, onPage = 10) =>
  useQuery({
    queryKey: queryKeys.recurringProfiles.list(page, onPage),
    queryFn: () =>
      fetcher({
        method: "GET",
        url: "/public/invoice/recurring-profiles",
        params: { page, on_page: onPage, include: "membership" },
      }),
    ...queryParams,
  });
